namespace SolovisGateway.Admin.Authentication {
    export class JwtAuthAppUserModel {
        id: number;
        code: string;
        primaryEmail: string;
        fullName: string;

        constructor(data: any) {
            if (data) {
                this.id = data.id;
                this.code = data.code;
                this.primaryEmail = data.primaryEmail;
                this.fullName = data.fullName;
            }
        }

        toDeleteParams(jwtAuthAppCode: string): { jwtAuthAppCode: string, userId: number, } {
            return {
                jwtAuthAppCode: jwtAuthAppCode,
                userId: this.id
            };
        }

        toAddParams(jwtAuthAppCode: string): { jwtAuthAppCode: string, userId: number, } {
            return {
                jwtAuthAppCode: jwtAuthAppCode,
                userId: this.id
            };
        }
    }
}